export const currencies = [
	{ currency: "btc", symbol: "₿" },
	{ currency: "eth", symbol: "Ξ" },
	{ currency: "ltc", symbol: "Ł" },
	{ currency: "bch", symbol: "BCH" },
	{ currency: "bnb", symbol: "BNB" },
	{ currency: "eos", symbol: "EOS" },
	{ currency: "xrp", symbol: "XRP" },
	{ currency: "xlm", symbol: "XLM" },
	{ currency: "link", symbol: "LINK" },
	{ currency: "dot", symbol: "DOT" },
	{ currency: "yfi", symbol: "YFI" },
	{ currency: "usd", symbol: "$" },
	{ currency: "aed", symbol: "د.إ" },
	{ currency: "ars", symbol: "$" },
	{ currency: "aud", symbol: "$" },
	{ currency: "bdt", symbol: "৳" },
	{ currency: "bhd", symbol: ".د.ب" },
	{ currency: "bmd", symbol: "$" },
	{ currency: "brl", symbol: "R$" },
	{ currency: "cad", symbol: "$" },
	{ currency: "chf", symbol: "CHF" },
	{ currency: "clp", symbol: "$" },
	{ currency: "cny", symbol: "¥" },
	{ currency: "czk", symbol: "Kč" },
	{ currency: "dkk", symbol: "kr" },
	{ currency: "eur", symbol: "€" },
	{ currency: "gbp", symbol: "£" },
	{ currency: "hkd", symbol: "$" },
	{ currency: "huf", symbol: "Ft" },
	{ currency: "idr", symbol: "Rp" },
	{ currency: "ils", symbol: "₪" },
	{ currency: "inr", symbol: "₹" },
	{ currency: "jpy", symbol: "¥" },
	{ currency: "krw", symbol: "₩" },
	{ currency: "kwd", symbol: "KD" },
	{ currency: "lkr", symbol: "රු." },
	{ currency: "mmk", symbol: "K" },
	{ currency: "mxn", symbol: "$" },
	{ currency: "myr", symbol: "RM" },
	{ currency: "ngn", symbol: "₦" },
	{ currency: "nok", symbol: "kr" },
	{ currency: "nzd", symbol: "$" },
	{ currency: "php", symbol: "₱" },
	{ currency: "pkr", symbol: "₨" },
	{ currency: "pln", symbol: "zł" },
	{ currency: "rub", symbol: "₽" },
	{ currency: "sar", symbol: "﷼" },
	{ currency: "sek", symbol: "kr" },
	{ currency: "sgd", symbol: "$" },
	{ currency: "thb", symbol: "฿" },
	{ currency: "try", symbol: "₺" },
	{ currency: "twd", symbol: "NT$" },
	{ currency: "uah", symbol: "₴" },
	{ currency: "vef", symbol: "Bs.F." },
	{ currency: "vnd", symbol: "₫" },
	{ currency: "zar", symbol: "R" },
	{ currency: "xdr", symbol: "SDR" },
	{ currency: "xag", symbol: "XAG" },
	{ currency: "xau", symbol: "XAU" },
	{ currency: "bits", symbol: "ƀ" },
	{ currency: "sats", symbol: "sat" },
];